import React, { createContext, useContext } from 'react';

const AgendaActionsContext = createContext(null);

export const AgendaActionsProvider = ({ value, children }) => (
  <AgendaActionsContext.Provider value={value}>
    {children}
  </AgendaActionsContext.Provider>
);

export const useAgendaActionsContext = () => {
  const context = useContext(AgendaActionsContext);
  if (!context) {
    throw new Error(
      'useAgendaActionsContext must be used within AgendaActionsProvider'
    );
  }
  return context;
};
